import React from 'react'
import { Button, useTheme } from "@mui/material";
export default function FilterButtons({ disabled, name, onClick }) {
    const theme = useTheme();
    const handleChange = (value) => {
        onClick(value);
    };
    return (
        <Button
            style={{
                backgroundColor: name === 'Reset' ? theme.palette.primary.main : theme.palette.primaryDark.light,
                borderRadius: "10px",
                width: "45px",
                height: "19px",
                color: theme.palette.background.main,
                textTransform: 'capitalize',
                minWidth: '50px'
            }}
            disabled={disabled}
            className="ff-Roboto fs-10 fw-medium "
            onClick={(value) => { handleChange(name) }}>
            {name}
        </Button>
    )
}
